(function trackerRecommendedCommunities(global) {
  'use strict';

  const isPriced = (price) => price && price !== '0';
  const isBasic = document.querySelector('#IsBasic') && document.querySelector('#IsBasic').value === 'True';

  /**
   * getCachedValues: Retrieves and caches DOM values used across multiple operations.
   * This function performs DOM queries once and returns them as an object for reuse.
   * @returns {Object} Object containing planId, specId, communityId, listingId.
   */
  const getCachedValues = () => {
    const element = document.querySelector('[data-detail-wrapper]');
    return {
      planId: element ? element.dataset.planId : null,
      specId: element ? element.dataset.specId : null,
      communityId: element ? element.dataset.community : null,
      listingId: element ? element.dataset.listingId : null
    };
  };

  const cachedValues = getCachedValues();

  const getMarketSession = (marketId, marketName, stateAbbreviation) => {
    if (marketId && marketName) {
      return `${marketName}, ${stateAbbreviation} - ${marketId}`;
    }
    return null;
  };
  const getLocation = (city, stateName) => {
    if (city) {
      return `${city}, ${stateName}`;
    }
    return stateName;
  };

  /**
   * buildSourceRequestKey: Builds the source request key by combining the lead GUID
   * with the selected community and/or listing identifier.
   * The key always starts with the lead GUID. If a community id is present and no listing id
   * is present, the key includes "-c<communityId>". If a listing id is present, the key
   * includes "-c<listingId>" and the community id suffix is omitted even if available.
   * @returns {string} The formatted source request key.
   */
  const buildSourceRequestKey = () => {
    const guid = global.NewHomeSource.GuidGenerator.leadGuid || global.NewHomeSource.GuidGenerator.generateGUID();
    const { communityId, listingId } = cachedValues;
    const hasListingId = listingId && listingId !== '0';
    let itemId = communityId && !hasListingId ? `-c${communityId}` : '';

    if (hasListingId) {
      itemId += `-c${listingId}`;
    }

    return `${guid}${itemId}`;
  };

  /**
   * trackDiscoverCommunitySegmentEvent: Gets the information of the communtity and
   * track the event related to the discover community on Segment.
   * @param {Element} element Html element related to the community on the discover community section.
   */
  function trackDiscoverCommunitySegmentEvent(element) {
    if (!element) {
      return;
    }

    if (element.dataset.processed === 'true') {
      return;
    }

    const segmentPrefix = 'segmentEvent';
    const datasetPropertyNames = Object.getOwnPropertyNames(element.dataset);
    const segmentAttributes = datasetPropertyNames.filter((propertyName) => propertyName.includes(segmentPrefix));

    if (segmentAttributes.length < 1) {
      return;
    }

    const segmentEvent = {
      eventType: 'segmentEvent'
    };
    for (let index = 0; index < segmentAttributes.length; index += 1) {
      const segmentEventAttribute = segmentAttributes[index].replace(segmentPrefix, '');
      segmentEvent[segmentEventAttribute.toLowerCase()] = element.dataset[segmentAttributes[index]];
    }

    // Adding source_request_key to be able to link the event with the
    // user action that triggered it, context in ticket: NHS20-6149
    if ('source_request_key' in segmentEvent) {
      segmentEvent.source_request_key = buildSourceRequestKey();
    }

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: segmentEvent
      }
    }));

    element.setAttribute('data-processed', true);
  }

  /**
   * trackDiscoverCommunityGA4Event: Gets the information of the communtity and
   * track the event related to the discover community on GA4.
   * @param {Element} element Html element related to the community on the discover community section.
   */
  function trackDiscoverCommunityGA4Event(element) {
    if (!element) {
      return;
    }

    if (element.dataset.ga4Processed === 'true') {
      return;
    }

    if (element.value === 'true') {
      return;
    }

    const values = JSON.parse(element.value);

    if (isBasic) {
      return;
    }

    const sourceRequestKey = buildSourceRequestKey();

    const params = {
      click_target: 'direct rec modal',
      button_name: 'Get More Info',
      event_type: 'TDV Events',
      currency_value: 'USD',
      value: 30,
      trustbuilder_reviews: values.HasBuilderReviews,
      price_reduction: values.PriceReductionLabel,
      min_price: values.PriceLow,
      max_price: values.PriceHigh,
      market_id: values.MarketId,
      market_name: values.MarketName,
      market_session: getMarketSession(values.MarketId, values.MarketName, values.StateAbbreviation),
      location: getLocation(values.City, values.StateName),
      community_name: values.CommunityName,
      community_status: values.MarketingStatusLabel || 'Normal',
      community_id: values.CommunityId,
      is_limited_availability: values.HasLimitedInformation,
      is_priced: isPriced(values.PriceLow) || isPriced(values.PriceHigh) ? 'True' : 'False',
      is_paid: 'True',
      is_refer_by_spotlight: values.IsReferBySpotlight ? 'True' : 'False',
      // setting is_spotlight to false as spotlight is a concept that does not apply to recommended communities
      // clarification around this is needed, context in ticket: NHS20-6740
      is_spotlight: 'False',
      zip_code: values.Zip,
      builder_id: values.BuilderId,
      builder_name: values.BrandName,
      position: element.dataset.ga4EventPosition,
      org_button_name: element.dataset.ga4EventOrg_button_name,
      source_request_key: sourceRequestKey
    };

    const ga4Event = {
      eventName: 'direct_rec_lead',
      params,
      eventType: 'GA4Event'
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: ga4Event
      }
    }));

    element.setAttribute('data-ga4-processed', true);
  }

  /**
   * trackDiscoverCommunitiesEventsHandler: Manages and handles the events
   * when the Get More Info button is clicked.
   * @param {Event} event object related to the event.
   */
  function trackDiscoverCommunitiesEventsHandler(event) {
    if (!event || !event.target || !event.target.closest('[data-get-brochure]')) {
      return;
    }

    const checkedCommunities = document.querySelectorAll('[data-recommended-checkbox]:checked');
    checkedCommunities.forEach(trackDiscoverCommunitySegmentEvent);
    checkedCommunities.forEach(trackDiscoverCommunityGA4Event);
  }

  global.document.addEventListener('click', trackDiscoverCommunitiesEventsHandler);
}(window));
